import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: (process.env.MODE == 'DEVELOPMENT' || process.env.MODE == 'LOCAL') ? process.env.FIREBASE_DEVELOPMENT_API_KEY : process.env.FIREBASE_API_KEY,
  authDomain: (process.env.MODE == 'DEVELOPMENT' || process.env.MODE == 'LOCAL') ? process.env.FIREBASE_DEVELOPMENT_AUTH_DOMAIN : process.env.FIREBASE_AUTH_DOMAIN,
  projectId: (process.env.MODE == 'DEVELOPMENT' || process.env.MODE == 'LOCAL') ? process.env.FIREBASE_DEVELOPMENT_PROJECT_ID : process.env.FIREBASE_PROJECT_ID,
  storageBucket: (process.env.MODE == 'DEVELOPMENT' || process.env.MODE == 'LOCAL') ? process.env.FIREBASE_DEVELOPMENT_STORAGE_BUCKET : process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: (process.env.MODE == 'DEVELOPMENT' || process.env.MODE == 'LOCAL') ? process.env.FIREBASE_DEVELOPMENT_SENDER_ID : process.env.FIREBASE_SENDER_ID,
  appId: (process.env.MODE == 'DEVELOPMENT' || process.env.MODE == 'LOCAL') ? process.env.FIREBASE_DEVELOPMENT_APP_ID : process.env.FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const dbFirestore = getFirestore(app);

export { dbFirestore, firebaseConfig };
